/**
 * Recently viewed products — localStorage-based.
 * Saves current product on load; renders a grid of previous products on demand.
 */
(function RecentlyViewed() {
  const STORAGE_KEY = 'rv_products';
  const MAX_ITEMS = 8;

  function getStored() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (_) {
      return [];
    }
  }

  function setStored(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (_) {}
  }

  function saveCurrentProduct(product) {
    if (!product || !product.id) return;

    const entry = {
      id: product.id,
      title: product.title,
      url: product.url,
      price: product.price,
      compare_at_price: product.compare_at_price || 0,
      image: product.featured_image || null,
      vendor: product.vendor || ''
    };

    let items = getStored().filter((p) => p.id !== product.id);
    items.unshift(entry);
    if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
    setStored(items);
  }

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: currency || 'USD'
    }).format((cents || 0) / 100);
  }

  function buildGrid(items, currency, excludeId) {
    const filtered = items.filter((p) => p.id !== excludeId);
    if (!filtered.length) return null;

    const grid = document.createElement('div');
    grid.className = 'rv-grid';

    filtered.forEach((product) => {
      const card = document.createElement('a');
      card.className = 'rv-card';
      card.href = product.url;

      const priceHtml =
        product.compare_at_price > product.price
          ? `<span class="rv-card__price rv-card__price--sale">${formatMoney(product.price, currency)}</span>
             <span class="rv-card__compare">${formatMoney(product.compare_at_price, currency)}</span>`
          : `<span class="rv-card__price">${formatMoney(product.price, currency)}</span>`;

      card.innerHTML = `
        <div class="rv-card__media">
          ${
            product.image
              ? `<img src="${product.image}" alt="${product.title}" class="rv-card__image" loading="lazy" width="300" height="375">`
              : `<div class="rv-card__image-placeholder"></div>`
          }
        </div>
        <div class="rv-card__content">
          <p class="rv-card__title">${product.title}</p>
          <div class="rv-card__prices">${priceHtml}</div>
        </div>
      `;

      grid.appendChild(card);
    });

    return grid;
  }

  function renderIntoSections(currency, excludeId) {
    document.querySelectorAll('[data-recently-viewed]').forEach((section) => {
      const items = getStored();
      const grid = buildGrid(items, currency, excludeId);
      const placeholder = section.querySelector('[data-rv-placeholder]');

      if (!grid) {
        section.hidden = true;
        return;
      }

      section.hidden = false;
      if (placeholder) {
        placeholder.replaceWith(grid);
      } else {
        const existing = section.querySelector('.rv-grid');
        if (existing) existing.replaceWith(grid);
        else section.appendChild(grid);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    const productNode = document.querySelector('[data-product-json]');
    const currencyNode = document.querySelector('[data-cart-drawer]');
    const currency = currencyNode?.dataset.cartCurrency || 'USD';

    let excludeId = null;
    if (productNode) {
      try {
        const product = JSON.parse(productNode.textContent || '{}');
        excludeId = product.id;
        saveCurrentProduct(product);
      } catch (_) {}
    }

    renderIntoSections(currency, excludeId);
  });
})();
